module.exports = __webpack_public_path__ + "img/ps-36.9d291b92.jpg";